import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { type IMapLayerItemProps, MapLayerItem } from './MapLayerItem.tsx';

export interface IMapLayerSortableItemProps extends IMapLayerItemProps {
  index: string;
}

export function MapLayerSortableItem(props: IMapLayerSortableItemProps) {
  const { index, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition, active } =
    useSortable({ id: index });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
    >
      <MapLayerItem {...otherProps} isSpaceForDrag={index === active?.id} />
    </div>
  );
}
